/* eslint-disable */
/* Note: this code is generated by generateSizingEnums.js, do not modify it */
import that from '../utilities/translationHelper'
const sizings = {
	"N-M-W": {
		text: that.context.translate('Size'),
		values: ["Narrow","Medium","Wide"]
	},
	"S-L": {
		text: that.context.translate('Size'),
		values: ["S","M","L"]
	},
	"S-M": {
		text: that.context.translate('Size'),
		values: ["S","M"]
	},
	"S-XL": {
		text: that.context.translate('Size'),
		values: ["S","M","L","XL"]
	},
	"S-XXL": {
		text: that.context.translate('Size'),
		values: ["S","M","L","XL","XXL"]
	},
	"SM-LXL": {
		text: that.context.translate('Size'),
		values: ["S/M","L/XL"]
	},
	"XS-L": {
		text: that.context.translate('Size'),
		values: ["XS","S","M","L"]
	},
	"XS-SM-LXL": {
		text: that.context.translate('Size'),
		values: ["XS","S/M","L/XL"]
	},
	"XS-SM-LXL-XXL": {
		text: that.context.translate('Size'),
		values: ["XS","S/M","L/XL","XXL"]
	},
	"XS-XL": {
		text: that.context.translate('Size'),
		values: ["XS","S","M","L","XL"]
	},
	"XS-XXL": {
		text: that.context.translate('Size'),
		values: ["XS","S","M","L","XL","XXL"]
	},
	"XSS-ML": {
		text: that.context.translate('Size'),
		values: ["XS/S","M/L"]
	},
	"XXS-XXL": {
		text: that.context.translate('Size'),
		values: ["XXS","XS","S","M","L","XL","XXL"]
	},
	"XXS-XXXL": {
		text: that.context.translate('Size'),
		values: ["XXS","XS","S","M","L","XL","XXL","XXXL"]
	},
	"XXXS-XXL": {
		text: that.context.translate('Size'),
		values: ["XXXS","XXS","XS","S","M","L","XL","XXL"]
	},
	"XXXS-XXXL": {
		text: that.context.translate('Size'),
		values: ["XXXS","XXS","XS","S","M","L","XL","XXL","XXXL"]
	},
	"XXXS-XXXXL": {
		text: that.context.translate('Size'),
		values: ["XXXS","XXS","XS","S","M","L","XL","XXL","XXXL","XXXXL"]
	},
	"XXXXS-XXXL": {
		text: that.context.translate('Size'),
		values: ["XXXXS","XXXS","XXS","XS","S","M","L","XL","XXL","XXXL"]
	},
	"XXXXS-XXXXL": {
		text: that.context.translate('Size'),
		values: ["XXXXS","XXXS","XXS","XS","S","M","L","XL","XXL","XXXL","XXXXL"]
	},
	"ONESIZE": {
		text: that.context.translate('Size'),
		values: ["One size"]
	},
	"PANTLENGTH": {
		text: that.context.translate('Pant length'),
		values: ["28","29","30","31","32","33","34","35","36","38","40","42","44"]
	},
	"PANTWAIST": {
		text: that.context.translate('Pant waist'),
		values: ["22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","38","40","42","44","46","48","50","52","54","56","58","60"]
	},
	"SHOECM": {
		text: that.context.translate('Size'),
		values: ["22.5","23","23.5","23.5","24","24","24.5","25","25.5","26","26.5","27","27.5","28","28.5","29","29.5","30","30.5","31","31.5","32","32.5","33","33.5","34","34.5","35","35.5","36","37","38","39","40"]
	},
	"SHOEEU": {
		text: that.context.translate('Size'),
		values: ["35.5","36","36.5","37.5","38","38.5","39","40","40.5","41","42","42.5","43","44","44.5","45","45.5","46","47","47.5","48","48.5","49","49.5","50","50.5","51","51.5","52","52.5","53.5","54.5","55.5","56.5"]
	},
	"SHOEUK": {
		text: that.context.translate('Size'),
		values: ["3","3.5","4","4.5","5","5.5","6","6","6.5","7","7.5","8","8.5","9","9.5","10","10.5","11","11.5","12","12.5","13","13.5","14","14.5","15","15.5","16","16.5","17","18","19","20","21"]
	},
	"SHOEUSFEMALE": {
		text: that.context.translate('Size'),
		values: ["5","5.5","6","6.5","7","7.5","8","8.5","9","9.5","10","10.5","11","11.5","12","12.5","13","13.5","14","14.5","15","15.5","16"]
	},
	"SHOEUSMALE": {
		text: that.context.translate('Size'),
		values: ["3","4","4.5","5","5.5","6","6.5","7","7.5","8","8.5","9","9.5","10","10.5","11","11.5","12","12.5","13","13.5","14","14.5","15","15.5","16","16.5","17","17.5","18","19","20","21","22"]
	},
	"SHORTWAIST": {
		text: that.context.translate('Size'),
		values: ["26","27","28","29","30","31","32","33","34","35","36","38","40","42","44","46","48","50"]
	},
	"WHEEL": {
		text: that.context.translate('Size'),
		values: ["700c","26IN","27.5IN","29IN","20IN","18IN"]
	}
}
export default sizings



// WEBPACK FOOTER //
// ./src/enums/sizings.js